import styled, { css } from "styled-components"
import breakpoint from "styled-components-breakpoint"

export const Header = styled.header`
  font-family: ${({ theme }) => theme.fonts.body.family}, sans-serif;
  gap: 32px;
  align-items: center;
  background-color: ${({ theme }) => theme.colors.primary};
  background-size: cover;
  padding: 88px 24px 32px;
  display: block;
  justify-content: center;
  display: flex;

  ${breakpoint("tablet")`
    justify-content: start;
    padding-left: 60px;
    padding-right: 60px;
    ${({ theme, headerHeight, headerTopPadding, headerBottomPadding }) => css`
      height: ${headerHeight}px;
      padding-top: ${headerTopPadding}px;
      padding-bottom: ${headerBottomPadding}px;
      background-color: ${theme.colors.profile.headerBg};
    `};
  `}

  ${(props) =>
    props.coverImage &&
    css`
      background-image: url(${(props) => props.coverImage});
    `}
`
